import type { FieldKeyNameMap } from '@/shared/api';

// TODO: Backend API must provide fields in one style (kebab or camel not both as is)
export const sendFormDataFieldsMap = {
  brandId: 'brand',
  brandName: 'brandname',
  modelId: 'model',
  modelName: 'modelname',
  modelYear: 'model_year',
  seatsId: 'seats',
  seatsName: 'seatsname',
  cylindersId: 'cylinders',
  cylinderName: 'cylindername',
  chassis: 'chassis',
  regYear: 'year_registration',
  plateType: 'plate_type',
  plateTypeName: 'platetypename',
  plateNumber: 'plate',
  vehicleValue: 'vehicle_value',
  qatarId: 'qatar_id',
  civilIdExpiryDate: 'civilIdExpiryDate',

  vehicleType: 'vehicle_type',
  vehicleTypeName: 'vehicletypename',
  vehicleShapeCode: 'shape',
  vehicleShapeName: 'shape_name',
  vehicleUsageCode: 'veh_usage_code',
  vehicleUsageName: 'veh_usage_name',

  policyDate: 'policy_date',
  name: 'first_name',
  surname: 'last_name',
  dob: 'birth_date',
  id: 'qatar_id',
  phone: 'phone',
  email: 'email',
  promocode: 'promocode',

  companyId: 'qatar_id',
  companyName: 'company_name',
  customerType: 'customer_type',

  callbackName: 'name',
};

export const defaultResponseKeysMap: FieldKeyNameMap = {
  policyNo: 'policyNumber',
  quoteNo: 'quoteNumber',
  currPremium: 'currentPrice',
  paidPremium: 'paidPrice',
  premium: 'price',
  pendingPremium: 'pendingPrice',
  instNo: 'installmentNumber',
  instDetailList: 'installmentDetails',
  totalpayment: 'totalPayment',
  autopaymentFailedYN: 'isAutoPaymentFailed',
  instPaidYN: 'isInstallmentPaid',
  isAutopayment: 'hasAutopayment',
  polStartDate: 'policyStartDate',
  polEndDate: 'policyEndDate',
  makeCode: 'brandCode',
  makeName: 'brandName',
  instYN: 'isInstallment',
  downgradedYN: 'isDowngraded',
  regnNo: 'plateNumber',
  regNo: 'plateNumber',
  emailId: 'email',
};

export const defaultRequestKeysMap: FieldKeyNameMap = {
  chassisNumber: 'chassisno',
  plateNumber: 'plateno',
  policyNumber: 'policyno',
  transId: 'transid',
  selectedInstallmentNumbers: 'selectedinstno',
  isFull: 'full',
  isSelectProduct: 'selectproduct',
};
